import { useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/store";
import driveIcon from "../../assets/images/googleDriveLogo.svg";
import UploadSVG from "../../assets/images/UploadIcon.svg";
import bookSparkSVG from "../../assets/book_spark.svg";
import Button from "../Button/Button";
import { LoadingButtonProps } from "@mui/lab";
import Typography from "../Typography/Typography";
import { ButtonProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LANDING_PAGE_TO_DASHBOARD_URLS } from "../../modules/vscDashboard/constants";
import { DASHBOARD_ENTITIES, ROUTES, UPLOAD_FILES_TO_CHAT_PROMPT_TEXT } from "../../common/constants";
import { CSSProperties } from "react";
import UploadSVGIcon from "../../assets/images/uploadIconOutlined.svg";
import UploadDoc from "../UploadDoc/UploadDoc";

export const ChooseFromDriveBtn = ({
  onClick,
  loading,
  disabled,
  fullWidth,
  style,
}: LoadingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      variant="outlined"
      endIcon={<img src={driveIcon} alt="" width="23px" />}
      style={{ borderColor: "#767680", ...style }}
      fullWidth={fullWidth}
      loadingPosition="end"
    >
      <Typography style={{ padding: "4px 0px" }} color="#767680">
        Upload From
      </Typography>
    </Button>
  );
};

export const SimpleButton = ({
  onClick,
  disabled,
  variant = "outlined",
  style,
  children,
  size = "small",
}: ButtonProps) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      size={size}
      style={style}
    >
      {children}
    </Button>
  );
};

interface ExtendedLoadingButtonProps extends LoadingButtonProps {
  customStyle?: CSSProperties;
}

export const UploadBtn = ({
  onClick,
  variant = "contained",
  disabled,
  loading,
  children,
  startIcon,
  customStyle,
}: ExtendedLoadingButtonProps) => {
  const styles = {
    borderRadius: "24px",
    padding: "4px 16px",
  };
  return (
    <Button
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      loading={loading}
      startIcon={
        startIcon ? startIcon : null
        // <img style={{ height: "20px" }} src={UploadSVG} alt="" />
      }
      style={
        disabled ? { backgroundColor: "#E8E8E8", ...styles,...customStyle } : { ...styles, ...customStyle }
      }
    >
      {children ? (
        children
      ) : (
        <Typography style={{ padding: "4px 0px", fontSize: "12px" }}>
          Upload
        </Typography>
      )}
    </Button>
  );
};

interface UploadButtonProps {
  onClick: () => void;
  loading: boolean;
  disabled: boolean;
  fullWidth: boolean;
  navigate: ReturnType<typeof useNavigate>;
  style?: CSSProperties;
}

export const UploadFileFromDriveBtn = ({
  onClick,
  loading,
  disabled,
  fullWidth,
  navigate,
  style,
}: UploadButtonProps) => {
  const [openModalState, setOpenModalState] = useState(false);
   const { vmoBot } = useAppSelector(
      (state) => state.rootReducer.vscDashboardReducer
    );
  const handleButtonClick = () => {
    setOpenModalState(true);
  };
   useEffect(() => {
    if (openModalState) {
      navigate(`${ROUTES.dashboardTabs}?cardType=${LANDING_PAGE_TO_DASHBOARD_URLS.ttc}`);
      onClick();
    }
  }, [openModalState]);
  return (
    <>
      <Button
        onClick={handleButtonClick}
        loading={loading}
        disabled={disabled}
        variant="outlined"
        endIcon={<img src={UploadSVGIcon} alt="" width="18px" height="18px" />}
        style={{
          background: "#FFFFFFB2",
          border: "1px solid #E2E2E2",
          borderRadius: "138px",
          justifyContent: "space-between",
          padding: "16px 24px",
          boxShadow: "0px 8px 24px 0px #00000014",
          ...style,
        }}
        fullWidth={fullWidth}
        loadingPosition="end"
      >
        <div style={{ width: "24px", height: "24px", marginRight: "8px" }}>
          <img src={bookSparkSVG} alt="book spark" />
        </div>
        <Typography style={{ padding: "4px 0px" }} color="#767680">
          {UPLOAD_FILES_TO_CHAT_PROMPT_TEXT}
        </Typography>
      </Button>
    </>
  );
};

export const DriveBtn = ({
  onClick,
  loading,
  disabled,
  fullWidth,
}: LoadingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      variant="outlined"
      endIcon={<img src={driveIcon} alt="" width="23px" />}
      fullWidth={fullWidth}
      loadingPosition="end"
      style={{
        border: "none",
      }}
    ></Button>
  );
};

export const UploadFileFromDriveBtnTtcChat = ({
  onClick,
  loading,
  disabled,
  fullWidth,
}: LoadingButtonProps) => {
  const [openModal, setOpenModal] = useState(false);
  const handleButtonClick = () => {
    setOpenModal(true);
  };
  return (
    <>
      <Button
        // onClick={onClick}
        onClick={handleButtonClick}
        loading={loading}
        disabled={disabled}
        variant="outlined"
        endIcon={<img src={UploadSVGIcon} alt="" width="18px" height="18px" />}
        style={{
          background: "#FFFFFFB2",
          border: "1px solid #E2E2E2",
          borderRadius: "138px",
          justifyContent: "space-between",
          padding: "10px 18px",
          boxShadow: "0px 8px 24px 0px #00000014",
        }}
        fullWidth={fullWidth}
        loadingPosition="end"
      >
        <div style={{ width: "24px", height: "24px", marginRight: "8px" }}>
          <img src={bookSparkSVG} alt="book spark" />
        </div>
        <Typography style={{ padding: "4px 0px" }} color="#767680">
          {UPLOAD_FILES_TO_CHAT_PROMPT_TEXT}
        </Typography>
      </Button>
      <UploadDoc
        openModal={openModal}
        setOpenModal={setOpenModal}
        dashboardEntity={DASHBOARD_ENTITIES.TALK_TO_CONTRACT}
      />
    </>
  );
};
